import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { AUTH_TOKEN, SELECTED_BRANCH } from '../../constants'
import { LOGIN_MUTATION } from '../../mutations'

import Footer from '../../components/Footer/'
import LoginForm from '../../containers/LoginForm/'
import BrancheList from '../../containers/BrancheList/'

import logo from '../../assets/logo.svg'
import desert from '../../assets/hero/login/desert.jpg'
import desertMobile from '../../assets/hero/login/desert-mobile.jpg'
import rock from '../../assets/hero/login/rock.jpg'
import rockMobile from '../../assets/hero/login/rock-mobile.jpg'
import sea from '../../assets/hero/login/sea.jpg'
import seaMobile from '../../assets/hero/login/sea-mobile.jpg'
import snow from '../../assets/hero/login/snow.jpg'
import snowMobile from '../../assets/hero/login/snow-mobile.jpg'

import { Container, Logo, BranchesContainer } from './styles'
import helpers from '../../helpers'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      branches: [],
      showBranches: false,
      feedback: '',
      hero: this.generateRandomImage(),
      stayLoggedIn: false,
      fullName: ''
    }
  }

  async handleLogin(username, password, stayLoggedIn) {
    try {
      const result = await this.loginMutation({
        variables: {
          data: {
            username: username,
            password: password
          }
        }
      })
      this.setState({ stayLoggedIn })

      const { token, user } = result.data.login
      const { branches } = user
      this.saveUserData(token, stayLoggedIn)
      let insertion = user.insertion ? user.insertion : ''
      insertion = helpers.findInsertion(insertion)
      this.setState({ fullName: user.firstName + ' ' + insertion + ' ' + user.lastName })
      if (branches.length > 1) {
        this.setState({ showBranches: true, branches })
      } else {
        if (stayLoggedIn) {
          window.localStorage.setItem(SELECTED_BRANCH, branches[0].id)
        } else {
          window.sessionStorage.setItem(SELECTED_BRANCH, branches[0].id)
        }
        this.props.history.push('/')
      }
    } catch (error) {
      console.error(error)
      this.setState({ feedback: 'Inloggen mislukt, controleer uw gegevens' })
    }
  }

  saveUserData(token, stayLoggedIn) {
    if (stayLoggedIn) {
      window.localStorage.setItem(AUTH_TOKEN, token)
    } else {
      window.sessionStorage.setItem(AUTH_TOKEN, token)
    }
  }

  handleClick(branch) {
    // this.props.login(branche)
    if (this.state.stayLoggedIn) {
      window.localStorage.setItem(SELECTED_BRANCH, branch)
    } else {
      window.sessionStorage.setItem(SELECTED_BRANCH, branch)
    }
    this.props.history.push('/')
  }

  generateRandomImage() {
    let images = [
      {
        desktop: desert,
        mobile: desertMobile
      },
      {
        desktop: rock,
        mobile: rockMobile
      },
      {
        desktop: sea,
        mobile: seaMobile
      },
      {
        desktop: snow,
        mobile: snowMobile
      }
    ]

    // randomnize
    return images[Math.floor(Math.random() * images.length)]
  }

  render() {
    const { showBranches, hero } = this.state

    return (
      <Container overlay={showBranches} image={hero.desktop} mobile={hero.mobile}>
        <Logo src={logo} alt="logo" />

        {showBranches ? (
          <BranchesContainer>
            <BrancheList
              handleClick={this.handleClick.bind(this)}
              title={`${this.state.fullName !== '' ? ('Welkom ' + this.state.fullName) : ''} - Kies uw filiaal`}
              branches={this.state.branches}
            />
          </BranchesContainer>
        ) : (
          <Mutation mutation={LOGIN_MUTATION}>
            {(loginMutation, { data, loading, error }) => {
              this.loginMutation = loginMutation
              return (
                <LoginForm
                  feedback={error ? error.message.split('GraphQL error:').pop() : this.state.feedback}
                  data={data}
                  loading={loading}
                  error={error}
                  login={this.handleLogin.bind(this)}
                />
              )
            }}
          </Mutation>
        )}

        <Footer type="transparent" />
      </Container>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/views/Login/index.js